var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintMerchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.48047H4C2.34315 6.48047 1 7.82361 1 9.48047V27.4805C1 29.1373 2.34315 30.4805 4 30.4805H9M33 6.48047H38C39.6569 6.48047 41 7.82361 41 9.48047V27.4805C41 29.1373 39.6569 30.4805 38 30.4805H33",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18V35C9 36.6569 10.3431 38 12 38H30C31.6569 38 33 36.6569 33 35V18",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1H30C31.6569 1 33 2.34315 33 4V11C33 11.5523 32.5523 12 32 12H10C9.44772 12 9 11.5523 9 11V4C9 2.34315 10.3431 1 12 1H15",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7V6C38 4.34315 36.6569 3 35 3H7C5.34315 3 4 4.34315 4 6V7",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H38",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 23.5,
    r: 2.5,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 10,
    r: 1.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 15,
    r: 1.5,
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30V30C17.4109 26.2861 12.1641 26.0175 9.70675 29.4988L9 30.5",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 32.5L23.1314 26.7201V26.7201C25.1656 24.686 28.4768 24.73 30.4562 26.8174L33 29.5M12 37.8516L15.7096 34.142",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintMerchIcon);
export default __webpack_public_path__ + "static/media/printMerchIcon.b2440bf66e38455866f8dc5b7ec4a0c6.svg";
export { ForwardRef as ReactComponent };